import { createStyles } from "@mantine/core";
import { CSSObject } from "@mantine/styles/lib/tss/types";
import { MantineTheme } from "@mantine/styles/lib/theme";

export type ThemeClasses = { [p: string]: string, [p: number]: string }

type Variations = {
  variant?: string;
  size: string | number;
}

export function createContentStyles<Key extends string = string, Params = void, Input extends Record<Key, CSSObject> = Record<Key, CSSObject>>(input?: ((theme: MantineTheme, params: Params, variations: Variations) => Input) | Input) {
  // @ts-ignore
  return createStyles<Key, Params, Input>((theme, params, variations) => {
    return {
      container: {
        backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[7] : theme.colors.gray[0]
      },
      ...(input ? (input instanceof Function ? input(theme, params, variations) : input) : {})
    };
  });
}
